import React from 'react';
import { Flex, Divider, TextV2 } from '@withjoy/joykit';

interface HotelMapProps {}

const HotelMap: React.FC<HotelMapProps> = () => {
  return (
    <>
      <Flex width={'100%'}>
        <Flex height={397} maxWidth={500} minWidth={327} width={'100%'} background={'lightblue'} borderRadius={'4px'}>
          <TextV2 fontWeight={400}>Hotel map placeholder</TextV2>
        </Flex>
      </Flex>
      <Divider display={{ _: 'flex', sm2: 'none' }} paddingTop={{ _: 8, sm2: 0 }} />
    </>
  );
};

HotelMap.displayName = 'HotelMap';

export { HotelMap };
